module.exports = __webpack_public_path__ + "img/bg4.2361f8b5.png";